import React from 'react';
import { FaBell } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">About Us</h2>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center mb-4">
              <FaBell className="text-gold-500 text-3xl mr-3" />
              <span className="text-2xl font-semibold text-gray-800">Tuneza Lodge</span>
            </div>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Welcome to Tuneza Lodge, the premier destination for exceptional hospitality in Ntchisi. 
              Tuneza Lodge prides itself on offering luxurious accommodations, state-of-the-art conferencing facilities, 
              and exquisite dining experiences.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Situated in a tranquil and secure environment with stunning natural surroundings, our lodge guarantees 
              a memorable stay for both business and leisure travelers. With a steadfast commitment to excellence 
              and customer satisfaction, we strive to provide a unique blend of modern comfort and natural beauty.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 mt-8">
              <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-gold-500">
                <h3 className="text-xl font-semibold text-gold-600 mb-3">Our Mission</h3>
                <p className="text-gray-600">
                  To solidify ourselves as the preferred hospitality service provider in Ntchisi and surrounding areas, 
                  serving local and international customers with unwavering dedication and excellence.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-gold-500">
                <h3 className="text-xl font-semibold text-gold-600 mb-3">Our Vision</h3>
                <p className="text-gray-600">
                  To deliver unique and internationally recognized service standards, ensuring that every guest 
                  experiences unparalleled comfort and satisfaction.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-lg overflow-hidden shadow-xl">
            <img src="/assets/about.jpg" alt="Tuneza Lodge" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;